export default "__VITE_ASSET__47c6d0ec__"